import { useEffect, useRef, useState } from "react";

export const useRenderStatus = (
  timeoutMs = 1000,
  start = true,
  loading = false
) => {
  const [busy, setBusy] = useState(true);
  const started = useRef(false);

  useEffect(() => {
    let timeout: NodeJS.Timeout | null = null;

    if (!started.current && start) {
      timeout = setTimeout(() => {
        started.current = true;
        setBusy(false);
      }, timeoutMs);
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [timeoutMs, start]);

  useEffect(() => {
    if (loading === false && start && started.current) {
      setBusy(false);
    }
  }, [loading, start]);

  return busy;
};
